// BasicConfig.tsx
import React, { useEffect } from 'react';
import { useFormContext, Controller, useWatch } from 'react-hook-form';
import Select from 'react-select';
import Input from '../../../forms/input.component';
import Icon from '../../../forms/icon.component';
import InvalidFeedback from '../../../forms/invalid-feedback.component';

const TYPE_OPTIONS = [
  { value: 'TEXT', label: 'Texto' },
  { value: 'BUTTONS', label: 'Botones' }
];

export const BasicConfig: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const {
    control,
    register,
    setValue,
    unregister,
    formState: { errors }
  } = useFormContext();

  const currentType = useWatch({
    control,
    name: 'interactive.type'
  });

  useEffect(() => {
    if (currentType === 'TEXT') {
      unregister('interactive.buttons');
      setValue('interactive.buttons', undefined);
    } else if (currentType === 'BUTTONS') {
      unregister('interactive.text');
      setValue('interactive.text', undefined);
    }
  }, [currentType]);

  return (
    <div
      className="modal fade show card d-block basic-interactive-modal"
      data-blendy-to="nodeModal"
    >
      <div className="card-body position-relative">
        <div
          className="position-absolute top-0 end-0 m-2 btn btn-icon btn-icon-danger fs-2x"
          onClick={() => onClose()}
        >
          <Icon icon="ki-cross" size="fs-2x" />
        </div>

        <h6 className="card-title mb-4">Información básica</h6>

        {/* Título */}
        <div className="mb-3">
          <Input
            label="Título del nodo"
            placeholder="Escribe el nombre del nodo"
            requiredIndicator="required"
            {...register('title', { required: 'Este campo es requerido' })}
            errors={errors.title?.message}
          />
        </div>

        {/* Tipo de interactivo */}
        <div className="mb-3">
          <label className="form-label">Tipo de interactivo</label>
          <Controller
            control={control}
            name="interactive.type"
            rules={{ required: 'Requerido' }}
            render={({ field }) => (
              <Select
                {...field}
                options={TYPE_OPTIONS}
                onChange={(opt) => field.onChange(opt?.value)}
                value={TYPE_OPTIONS.find((o) => o.value === field.value) || null}
                classNamePrefix="form-select-custom"
                placeholder="Selecciona tipo"
                menuPosition="fixed"
              />
            )}
          />
          <InvalidFeedback error={errors.interactive?.type} />
        </div>

        {/* Botón para cerrar */}
        <div className="text-end">
          <button type="button" className="btn btn-sm btn-primary" onClick={() => onClose()}>
            Listo
          </button>
        </div>
      </div>
    </div>
  );
};
